import {
  FETCH_AI_HISTORY,
  FETCH_AI_HISTORY_SUCCESS,
  FETCH_AI_HISTORY_ERROR,
  SET_AI_PANEL,
  ADD_AI_MESSAGE,
  UPDATE_AI_MESSAGE,
  SET_AI_WEB_WORKER,
  SET_AI_STATUS,
  START_STREAMING_AI_MESSAGE,
  SET_STREAMING_AI_MESSAGE,
  UPDATE_STREAMING_AI_MESSAGE_CONTENT,
  CLEAR_STREAMING_MESSAGE_CONTENT,
  SET_ERROR_STREAMING_AI_MESSAGE,
  RESET_STREAMING_AI_MESSAGE,
  SET_AI_USER_PROMPT,
  SET_AI_USER_PROMPT_WITH_OPTIONS,
  GIVE_POSITIVE_FEEDBACK,
  GIVE_NEGATIVE_FEEDBACK,
  GIVE_UNDO_FEEDBACK,
} from './constants';

export function fetchAISurveyBuilderHistory(id) {
  return {
    type: FETCH_AI_HISTORY,
    id,
  };
}

export function fetchAISurveyBuilderHistorySuccess(payload) {
  return {
    type: FETCH_AI_HISTORY_SUCCESS,
    payload,
  };
}

export function fetchAISurveyBuilderHistoryError(payload) {
  return {
    type: FETCH_AI_HISTORY_ERROR,
    payload,
  };
}

export function setAiPanelState(payload) {
  return {
    type: SET_AI_PANEL,
    payload,
  };
}

export function addAiMessage(payload) {
  return {
    type: ADD_AI_MESSAGE,
    payload,
  };
}

export function updateAiMessage(payload) {
  return {
    type: UPDATE_AI_MESSAGE,
    payload,
  };
}

export function setAiWebWorker(payload) {
  return {
    type: SET_AI_WEB_WORKER,
    payload,
  };
}

export function setAiStatus(status) {
  return {
    type: SET_AI_STATUS,
    status,
  };
}
export function startStreamingAiMessage(payload) {
  return {
    type: START_STREAMING_AI_MESSAGE,
    payload,
  };
}
export function setStreamingAiMessage(payload) {
  return {
    type: SET_STREAMING_AI_MESSAGE,
    payload,
  };
}

export function updateStreamingAiMessageContent(payload) {
  return {
    type: UPDATE_STREAMING_AI_MESSAGE_CONTENT,
    payload,
  };
}
export function setErrorStreamingMessage(payload) {
  return {
    type: SET_ERROR_STREAMING_AI_MESSAGE,
    payload,
  };
}
export function resetStreamingMessage() {
  return {
    type: RESET_STREAMING_AI_MESSAGE,
  };
}

export function setAiUserPrompt(payload) {
  return {
    type: SET_AI_USER_PROMPT,
    payload,
  };
}

export function setAiUserPromptWithOptions(payload) {
  return {
    type: SET_AI_USER_PROMPT_WITH_OPTIONS,
    payload,
  };
}

export function clearStreamingMessageContent() {
  return {
    type: CLEAR_STREAMING_MESSAGE_CONTENT,
  };
}

export function givePositiveFeedback(payload) {
  return {
    type: GIVE_POSITIVE_FEEDBACK,
    payload,
  };
}

export function giveNegativeFeedback(payload) {
  return {
    type: GIVE_NEGATIVE_FEEDBACK,
    payload,
  };
}

export function giveUndoFeedback(payload) {
  return {
    type: GIVE_UNDO_FEEDBACK,
    payload,
  };
}
